import { EmptyView } from '@components'

import { ModuleLayout } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { NotFound } from '../../../../../../assets/images'
import { getOrganizationViewUrl } from '../../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'

export const DocumentLinkErrorState = (): ReactElement => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { organization } = useUserOrganization()

  const handleGoToDashboardClick = useCallback(() => {
    const dashboardUrl = getOrganizationViewUrl(organization?.url, reactRoute.organization.dashboard.getMainRoute())
    navigate(dashboardUrl)
  }, [navigate, organization?.url])

  return (
    <ModuleLayout fullHeight fullWidth title={t('navigation.menu.label.documents')} withMenuOffset={false}>
      <EmptyView
        illustration={<NotFound />}
        onClick={handleGoToDashboardClick}
        showCTA
        tButton="documents.open_link.access_denied.button"
        tDescription="documents.open_link.access_denied.description"
        tTitle="documents.open_link.access_denied.title"
      />
    </ModuleLayout>
  )
}
